import { createTheme } from '@mui/material';

const sharedTypography = {
  fontFamily: '"Inter", "Roboto", sans-serif',
  h4: { fontFamily: '"Playfair Display", serif', fontWeight: 700 },
  h5: { fontFamily: '"Playfair Display", serif', fontWeight: 700 },
  h6: { fontFamily: '"Playfair Display", serif', fontWeight: 600 },
};

const sharedShape = { borderRadius: 12 };

export const warmCinematicTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#0a0805',
      paper: '#1a1410',
    },
    primary: { main: '#e8b86d' },
    secondary: { main: '#f97316' },
    text: {
      primary: '#f5f0e8',
      secondary: '#9a8870',
    },
  },
  typography: sharedTypography,
  shape: sharedShape,
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          background: '#1c1810',
          border: '1px solid rgba(232, 184, 109, 0.1)',
          boxShadow: '0 4px 16px rgba(0,0,0,0.4)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'rgba(10, 8, 5, 0.92)',
          backdropFilter: 'blur(12px)',
          borderBottom: '1px solid rgba(232, 184, 109, 0.12)',
          boxShadow: 'none',
        },
      },
    },
    MuiBottomNavigation: {
      styleOverrides: {
        root: {
          background: 'rgba(10, 8, 5, 0.95)',
          backdropFilter: 'blur(12px)',
          borderTop: '1px solid rgba(232, 184, 109, 0.12)',
          height: 64,
        },
      },
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: { color: '#7a6040' },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { background: '#1a1410', border: '1px solid rgba(232,184,109,0.15)' },
      },
    },
  },
});
